import React from "react";
import styled from "styled-components";

const Lottie = React.lazy(() =>
  import("@lottielab/lottie-player/react").then((mod) => ({
    default: mod.default,
  })),
);

export const StyledLottieContainer = styled(Lottie)`
  aspect-ratio: 1920/720;
  inset: 0;
  position: absolute;
  z-index: 10;
  opacity: 1;
  max-height: 720px;
  animation: slideToLeft 0.3s forwards;

  svg {
    height: 720px !important;
  }

  @keyframes slideToLeft {
    0% {
      transform: translateX(10%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;
